import React from 'react'
import { Link } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import { Paper, ListItem, List, withStyles, WithStyles } from '@zn-material-ui'
import { isPingAn } from '@utils'
import styles from '../styles/MenuStyle'
import { transform } from '@utils/intl_lang'
const LIVE_LIST = /\/home\/livelist\/(1|2)/
const EXAM_LIBRARY = /\/home\/examLibrary\//

const Menus = [
  // '首页'
  {
    name: transform('home'),
    path: '/home/homePage',
    key: 'homePage',
    type: -1,
    isShow: true,
  },
  // '课程'
  {
    name: transform('course'),
    path: '/home/course',
    key: 'course',
    type: 0,
    isShow: false,
  },
  // '直播'
  {
    name: transform('live'),
    path: '/home/livelist/1',
    activeRule: LIVE_LIST,
    key: 'livelist',
    type: 31,
    isShow: false,
  },
  // '短视频'
  {
    name: transform('short_video'),
    path: '/home/liteVideo',
    key: 'liteVideo',
    type: 72,
    isShow: false,
  },
  // '公开考试'
  {
    name: transform('public_exam'),
    path: '/home/publicExam',
    key: 'publicExam',
    type: 30,
    isShow: false,
  },
  // '面授班'
  {
    name: transform('training_class'),
    path: '/home/trainingClass',
    key: 'trainingClass',
    type: 51,
    isShow: false,
  },
  // '资讯'
  {
    name: transform('infor_list'),
    path: '/home/inforList',
    key: 'inforList',
    type: 1,
    isShow: false,
  },
  // '文库'
  {
    name: transform('Knowledge_lib'),
    path: '/home/KnowledgeLib',
    key: 'KnowledgeLib',
    type: 70,
    isShow: false,
  },
  // '知圈'
  {
    name: transform('intelligent_circle'),
    path: '/home/communicateCenter',
    key: 'communicateCenter',
    type: 84,
    isShow: false,
  },
  // '知识云'
  // {
  //   name: transform('knowledge_cloud'),
  //   path: `${window.location.origin}/znWeb/knowledge-cloud/#/home`,
  //   key: 'knowledgeCloud',
  //   type: 118,
  //   isShow: false,
  // },
]
export interface IProps extends WithStyles<typeof styles> {
  location: RouteComponentProps['location']
  operationList: object[]
  route?: RouteComponentProps
}
const MenuListComposition = (props: IProps) => {
  const { classes, location, operationList = [] } = props
  const currentRoute = location.pathname

  const _menus = [...Menus]
  if (isPingAn()) {
    if (!_menus.find(m => m.key === 'examLibrary')) {
      _menus.push({ name: transform('question_bank'), path: '/home/examLibrary/', key: 'examLibrary', type: 65, isShow: false, activeRule: EXAM_LIBRARY })
    }
  }

  const operationMenu = _menus.map((item: any) => {
    const isShow =
      item.key === 'homePage' ||
      operationList.some((operation: any) => operation.id === item.type)
    return { ...item, isShow }
  })
  const isActiveMenus = (item: any) => {
    if (item.activeRule) {
      return item.activeRule.test(currentRoute)
    }
    return currentRoute === item.path
  }

  const menuMap = {
    'homePage': '首页',
    'course': '课程',
    'livelist': '直播',
    'liteVideo': '短视频',
    'publicExam': '公开考试',
    'trainingClass': '面授班',
    'inforList': '资讯',
    'KnowledgeLib': '文库',
    'communicateCenter': '知圈',
    // 'knowledgeCloud': '知识云',
    'examLibrary': '题库',
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <List className={classes.menuList}>
          {operationMenu.map((item: any) =>
            (item.isShow || item.type === 65) ? (
              <ListItem
                classes={{ selected: classes.selected }}
                selected={isActiveMenus(item)}
                className={classes.menuItem}
                key={item.key}
                // zn-i18n-disable-next-line
                data-event-category="01Web-智门户首页"
                // zn-i18n-disable-next-line
                data-event-label="0108Web-切换菜单"
                data-event-mapkv={JSON.stringify({
                  // zn-i18n-disable-next-line
                  from: '01Web-智门户首页',
                  main_menu: menuMap[item.key],
                })}
              >
                {item.path.includes('/#/') ? (
                  <a href={item.path} target="_blank">
                    {item.name}
                  </a>
                ) : (
                  <Link to={item.path}>{item.name}</Link>
                )}
              </ListItem>
            ) : null
          )}
        </List>
      </Paper>
    </div>
  )
}

export default withStyles(styles)(MenuListComposition)
